import React from 'react';
import {
  Box,
  Stack,
  Typography,
} from '@mui/material';
import {
  ErrorBox,
  ErrorTitle,
  ErrorMessage,
} from '@marageti/z4-lib';
import { ReactComponent as ZicassoSVG } from '../../assets/svg/zicasso.svg';
import ZSpinner from '../../components/z-lib/z-spinner';
import { ViewProps } from './types';
import './activate.scss';
import GoogleLoginView from '../../components/auth/google-sso-button';

const View = ({
  loading,
  loginError = undefined,
  onGoogleSSOSubmit,
}: ViewProps): React.ReactElement => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Stack
      spacing={3}
      sx={{
        width: { mobile: '342px', desktop: '333px' },
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Stack flexDirection="column" spacing="10px" alignItems="center">
        <ZicassoSVG aria-label="Zicasso" />
      </Stack>
      {loading && (
      <ZSpinner />
      )}
      <Stack flexDirection="column" spacing="10px" alignItems="center">
        <Typography color="text.secondary" style={{ marginTop: '10px' }}>
          Please sign in to activate your account.
        </Typography>
      </Stack>
      <Box
        display="flex"
        justifyContent="center"
      >
        <GoogleLoginView onSuccess={onGoogleSSOSubmit} />
      </Box>
      {loginError && (
        <ErrorBox>
          <ErrorTitle>
            There was an on our end.
          </ErrorTitle>
          {loginError.code ? (
            <ErrorMessage>
              {loginError.code && `Code: ${loginError.code} `}
              {loginError.message || 'Please contact support'}
              <br />
              {loginError.id && `ID: ${loginError.id}`}
            </ErrorMessage>
          ) : (
            <ErrorMessage>
              Please contact support.
            </ErrorMessage>
          )}
        </ErrorBox>
      )}
    </Stack>
  </Box>
);

export default View;
